import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorDialogService {

  private readonly errorSubject = new Subject<any>();

  public readonly error$: Observable<any> = this.errorSubject.asObservable();

  constructor() {
    console.log('ErrorDialogService loaded');
  }

  public showErrorDialog(dialogData: any = null): void { 
    this.errorSubject.next(dialogData);
  }
}